import { useCallback, useMemo } from "react";
import { addEntityAtIndex } from "./addEntityAtIndex.js";
import { throwNoopError } from "./errors.js";
import { moveEntity } from "./moveEntity.js";
import { sortEntities } from "./sortEntities.js";
import { useDesugaredRelativeSingleField } from "../accessorPropagation/useDesugaredRelativeSingleField.js";
const addNewAtIndexImplementation = (callbackName, entityList, desugaredSortableByField, index, preprocess) => {
  if (!desugaredSortableByField) {
    if (index === entityList.length) {
      return entityList.createNewEntity(preprocess);
    }
    return throwNoopError(callbackName);
  }
  addEntityAtIndex(entityList, desugaredSortableByField, index, preprocess);
};
const useSortedEntities = (entityList, sortableByField) => {
  const desugaredSortableByField = useDesugaredRelativeSingleField(sortableByField);
  const addNewAtIndex = useCallback(
    (index, preprocess) => {
      addNewAtIndexImplementation(
        "addNewAtIndex",
        entityList.getAccessor(),
        desugaredSortableByField,
        index ?? entityList.getAccessor().length,
        preprocess
      );
    },
    [desugaredSortableByField, entityList]
  );
  const prependNew = useCallback(
    (preprocess) => {
      addNewAtIndexImplementation(
        "prependNew",
        entityList.getAccessor(),
        desugaredSortableByField,
        0,
        preprocess
      );
    },
    [desugaredSortableByField, entityList]
  );
  const appendNew = useCallback(
    (preprocess) => {
      addNewAtIndexImplementation(
        "appendNew",
        entityList.getAccessor(),
        desugaredSortableByField,
        entityList.getAccessor().length,
        preprocess
      );
    },
    [desugaredSortableByField, entityList]
  );
  const normalizedMoveEntity = useCallback(
    (oldIndex, newIndex) => {
      if (!desugaredSortableByField) {
        return throwNoopError("moveEntity");
      }
      moveEntity(entityList.getAccessor(), desugaredSortableByField, oldIndex, newIndex);
    },
    [desugaredSortableByField, entityList]
  );
  const sortedEntities = useMemo(() => {
    return sortEntities(Array.from(entityList), desugaredSortableByField);
  }, [desugaredSortableByField, entityList]);
  return useMemo(
    () => ({
      entities: sortedEntities,
      addNewAtIndex,
      appendNew,
      prependNew,
      moveEntity: normalizedMoveEntity
    }),
    [sortedEntities, addNewAtIndex, appendNew, prependNew, normalizedMoveEntity]
  );
};
export {
  useSortedEntities
};
//# sourceMappingURL=useSortedEntities.js.map
